import { render } from "./PlyrPlayer.vue?vue&type=template&id=0c7eb4e8&scoped=true"
import script from "./PlyrPlayer.vue?vue&type=script&lang=js"
export * from "./PlyrPlayer.vue?vue&type=script&lang=js"

import "./PlyrPlayer.vue?vue&type=style&index=0&id=0c7eb4e8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c7eb4e8"]])

export default __exports__